<template>
    <div class="single-form-data">
        <el-form :form="formData" ref="form" :model="formData" :rules="rules" label-position="right" label-width="80px">
            <template v-for="(item, index) in dict">
                <el-form-item :label="item.display_name" v-if="item.field_type === 'select'" :key="index"
                    :prop="item.name" filterable clearable>
                    <ESelect v-model="formData[item.name]" :placeholder="item.placeholder" style="width: 300px"
                        :disabled="disabled(item)">
                        <el-option v-for="item in getOptions(item) || []" :key="item.id" :label="item.name"
                            :value="item.id">
                        </el-option>
                    </ESelect>
                </el-form-item>
                <el-form-item :label="item.display_name" v-if="item.field_type === 'multiselect' && item.name !== 'customer_id'" :key="index"
                    :prop="item.name">
                    <ESelect v-model="formData[item.name]" :placeholder="item.placeholder" filterable clearable
                        multiple collapse-tags style="width: 300px" :disabled="disabled(item)">
                        <el-option v-for="item in getOptions(item) || []" :key="item.id" :label="item.name"
                            :value="item.id">
                        </el-option>
                    </ESelect>
                </el-form-item>
                <el-form-item :label="item.display_name" v-if="item.field_type === 'multiselect' && item.name === 'customer_id'" :key="index"
                    :prop="item.name">
                    <ESelect v-model="formData[item.name]" :placeholder="item.placeholder" filterable clearable
                        multiple remote collapse-tags reserve-keyword :loading="searchLoading"
                        :remote-method="appEntryCustomerList" style="width: 300px" :disabled="disabled(item)" :no-data-text="noDataText">
                        <!-- <p class="option-select">
                            <el-button type="text" @click="() => handleSelectAll(customerList)">全选</el-button>
                            <el-button type="text" @click="() => formData.customer = []">取消全选</el-button>
                        </p> -->
                        <el-option v-for="item in customerList" :key="item.id" :label="item.name" :value="item.id">
                        </el-option>
                    </ESelect>
                </el-form-item>
                <el-form-item :label="item.display_name"
                    v-if="item.field_type === 'radio' && !!getOptions(item) && getOptions(item).length !== 0"
                    :key="index" :prop="item.name">
                    <el-radio-group v-model="formData[item.name]" :disabled="disabled(item)" style="width: 300px">
                        <el-radio v-for="item in getOptions(item) || []" :key="item.id" :label="item.id">
                            {{ item.name }}
                        </el-radio>
                    </el-radio-group>
                </el-form-item>

                <div class="app_info_name" v-if="shouldShow(item)">产品信息</div>

                <el-form-item :label="item.display_name"
                    v-if="item.field_type === 'text' && !!getOptions(item) && getOptions(item).length !== 0"
                    :key="index" :prop="item.name">
                    <el-input v-model="formData[item.name]" :placeholder="item.placeholder" style="width: 300px"
                        :disabled="disabled(item)" />
                </el-form-item>

            </template>

        </el-form>
    </div>
</template>

<script>

import { validEmoji, validHtml } from '@/utils/validate'
import { getAppEntryCustomerListApi, getAppEntryValidation } from '@/api'
import { error } from 'jquery';

export default {
    name: 'Single',
    props: ['dict', 'type'],
    data() {
        const validWordCount = (rule, value, callback) => {
            if (value.length > 100) {
                callback(new Error('最多输入100个字符'))
            } else {
                callback()
            }
        }
        const validContent = (rule, value, callback) => {
            const test = /\s/g
            if (validHtml(value) || validEmoji(value) || test.test(value)) {
                callback(new Error('不可包含空格、表情、html'))
            } else {
                callback()
            }
        };
        const validName = (rule, value, callback) => {
            const test = /^(?!-).+(?<!-)$/
            if (!test.test(value)) {
                callback(new Error('-不可在开头与结尾'))
            } else {
                callback()
            }
        }
        const validId = (rule, value, callback) => {
            const test = /^(?!.*__)[A-Za-z0-9]+(_[A-Za-z0-9]+)?$/
            if (test.test(value)) {
                callback()
            } else {
                callback(new Error('只可包含【数字、单词、_】，_不可在开头与结尾且_只能输入一个'))
            }
        }
        return {
            customerList: [],
            searchLoading: false,
            app_info_num: 0,
            formData: {
                // plat_id: '1',
                // app_type: '2',
                // package_type: '11',
                // customer_id:[],
                // game_classify: '3',
                // subproject_name:'',
                // subproject_id:'',
                // subprojet_content:''
            },
            rules: {
                // customer_id: [
                //     { required: true, message: '请绑定客户', trigger: 'change', value: null }
                // ],
                // plat_id: [
                //     { required: true, message: '请选择媒体', trigger: 'blur' }
                // ],
                // id: [
                //     { required: true, message: '请输入', trigger: 'blur' },
                //     { validator: validWordCount, trigger: 'blur' },
                //     { validator: validId, trigger: 'blur' },
                // ],
                // name: [
                //     { required: true, message: '请输入产品名称', trigger: 'blur' },
                //     { validator: validWordCount, trigger: 'blur' },
                //     { validator: validContent, trigger: 'blur' },
                //     { validator: validName, trigger: 'blur' },
                // ] ,
            },
            noDataText: '无数据'
        }
    },
    computed: {
    },
    watch: {
        'dict': {
            handler(n) {
                if (n) {
                    this.$nextTick(() => {
                        this.getRulesToFrom()
                    })
                }

            },
            immediate: true
        },
        'formData': {
            handler(n) {
                this.getValidationList(n)
            },
            deep: true
        }
    },
    activated() {
        this.$forceUpdate()
    },
    methods: {
        getRulesToFrom() {
            let vali_list = this.dict && this.dict.filter(ele => !!ele.validation)
            let app_info_list = this.dict && this.dict.filter(ele => ele.ext_config['tag'] && ele.ext_config['tag'] === 'app_info')
            let rules = vali_list.reduce((pre, item) => {
                return {
                    ...pre,
                    [item.name]: item.validation.map(v=>{
                        if(v.validation_type === 'regex') {
                            v.pattern = new RegExp(v.pattern)
                        }
                        if(v.validation_type === 'required') {
                            return {
                                "message": v.message,
                                "required": v.required,
                                "trigger": v.trigger
                            }
                        }else{
                            return {...v}
                        }
                    })
                }
            }, {})
            let data = vali_list.reduce((pre, item) => {
                let name = null
                if (item.name === 'plat_id') {
                    name = item.optionsSource[0]['id']
                } else {
                    name = ''
                }
                return {
                    ...pre,
                    [item.name]: name
                }
            }, {})
            this.$set(this, 'formData', data)
            // this.$set(this, 'rules', rules)
            this.$nextTick(() => {
                this.$refs['form'].clearValidate()
            })
        },
        async appEntryCustomerList(search) {
            // 广州声动网络科技有限公司   未找到该客户，新客户请联系客服前往ERP系统录入该客户后再次搜索
            if (!this.formData['plat_id']) {
                return this.$message.error('请先选择媒体')
            }
            try {
                this.searchLoading = true
                const params = {
                    search,
                    plat_id: this.formData['plat_id']
                }
                const { data, info } = await getAppEntryCustomerListApi(params);
                if(!!info) {
                    this.noDataText = '未找到该客户，新客户请联系客服前往ERP系统录入该客户后再次搜索'
                }else{
                    this.noDataText = '无数据'
                }
                this.customerList = data.list
            } catch (error) {
                this.$message.error(error.info)
            } finally {
                this.searchLoading = false
            }
        },
        handleSelectAll(list) {
            const data = [...(this.formData.customer || [])];
            data.push(...list.map(v => v.id));
            // 去重 赋值
            this.formData.customer = [...new Set(data)]
        },
        // 获取表单 下拉数据，并且是否显示
        getOptions(params) {
            const { dependencies, optionsSource, option } = params;
            if (dependencies.length === 0) {
                return option || optionsSource
            }
            let result = dependencies.map(item => {
                return this.formData[item]
            })
            let dict = result && result.reduce((prev, key, index, array) => {
                if (!Array.isArray(prev)) {
                    if (prev && prev[key] !== undefined) {
                        return prev[key];
                    } else {
                        return undefined;
                    }
                } else {
                    return prev
                }

            }, optionsSource)
            if (this.formData[params.name]) {
                // let icluced = dict && dict.some(item => typeof item === 'object' && item.id === this.formData[params.name])
                // if (!icluced && dict && dict.length !== 0) {
                //     this.formData[params.name] = dict[0]?.id
                // }
                // console.log('dict', dict,params.name, this.formData[params.name])
                
                // if(dict.length === 0) {
                //     this.formData[params.name] = null
                // }
            }
            // if(dict.length === 0) {
            //     this.formData[params.name] = null
            // }

            


            
            

            return dict
        },
        getValidationList(item) {
            getAppEntryValidation({type:'add', ...item}).then(res=>{
                if(!res.data || res.data.length === 0) return
                this.$set(this, 'rules', res.data)
                this.$nextTick(() => {
                    // let cur_arr = ['plat_id', 'app_type', 'package_type', 'customer_id', 'game_classify']
                    // let quchu_arr = Object.keys(this.formData).filter(ele=>!cur_arr.includes(ele))
                    this.$refs['form'].clearValidate()
                })
            }, error=>{
                this.$message.error(error.info)
            })
        },
        shouldShow(item) {
            let app_info_list = this.dict.filter(ele => ele.ext_config['tag'] && ele.ext_config['tag'] === 'app_info')
            let cur_id = app_info_list && app_info_list.length !== 0 ? app_info_list[0]['id'] : ''
            if (item.field_type === 'text' && item.ext_config['tag'] && item.ext_config['tag'] === 'app_info' && item.id === cur_id) {
                return true
            }
            return false
        },
        // 禁用
        disabled(item) {
            // if (this.type === 'edit') {
            //     return !item.ext_config['edit_editable']
            // } else if (this.type === 'add') {
            //     return !item.ext_config['add_editable']
            // }
            return !item.ext_config['add_editable']
        },
        filterNonEmpty(obj) {
        // 过滤掉值为空的属性
            return Object.fromEntries(
                Object.entries(obj).filter(([key, value]) => value != null && value !== '')
            );
        },
        async getFormData() {
            const valid = await this.$refs['form'].validate();
            if (valid) {
                let result_formData = this.filterNonEmpty(this.formData)
                return [
                    {...result_formData}
                ]
            }
        },
    }
}
</script>

<style lang="scss" scoped>
.bold {
    font-weight: bold;
}

.information {
    border: 1px solid #ccc;
    padding: 12px 20px 0 20px;
    min-height: 140px;

    .info-tip {
        font-size: 12px;
        color: #aaa;
        padding-left: 50px;
    }
}

.single-form-data {
    .app_info_name {
        padding-bottom: 10px;
        margin-bottom: 10px;
        border-bottom: 1px solid #dadada;
    }
    ::v-deep.el-form-item{
        display: flex;
        align-items: center;
        ::v-deep.el-form-item__content{
            margin-left: 0 !important;
        }
        ::v-deep.el-form-item__label {
            line-height: 20px !important;
        }
    }
}
</style>